export const JITSI_DOMAIN = 'jitsi.progkids.com';
// export const JITSI_DOMAIN = 'ji.progkids.com';
